<template>
    <div v-if="notice" class="notice-modal text-center">
        <div class="notice-body text-center">
            <div  v-html="message"></div>
            <button type="button" class="btn btn-primary" @click="cmdOK">{{btnMessage}}</button>
        </div>
    </div>
</template>

<script>
  export default {
    name: "notice-modal",
    computed: {
        notice: function() {
          // wyświetla modal jeśli active jest true
          return this.$store.state.noticeModal.active
        },
        klass: function() {
          return this.$store.state.noticeModal.klass
        },
        btnMessage: function() {
          return this.$store.state.noticeModal.buttonMessage
        },
        message: function() {
          let content = this.$store.state.noticeModal.content;
          if(content instanceof Object){
            let result = '<ul>';
            for(let key in content){
              result += "<li>" + content[key] + "</li>"
            }
            result += "</ul>";
            return result;
          } else {
            return content
          }
        }
    },
    methods: {
      cmdOK: function(){
        let js_klass = this.$store.state.noticeModal.klass
        if (js_klass == 'js-redirect-agreement') {
          window.open('https://carq.pl/autos/new', '_blank')
        }
        this.$store.commit('closeNotice')
      }
    }
  }
</script>

<style lang="scss" scoped>
    .notice-modal {
        position: fixed;
        z-index: 100;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(100,100,100,0.8);

        .notice-body {
            position: relative;
            top: 50px;
            width: 350px;
            background: white;
            border-radius: 5px;
            padding: 20px;
            font-size: large;
            margin: 0 auto;

            button {
                margin-top: 20px;
                padding: 10px 30px;
                font-size: large;
                font-weight: bold;
            }
        }
    }
</style>